// Verdicts the n8n image check (uniform-check / conveyance-check) writes on ck_image_processing.
export enum ImageCheckVerdictEnum {
  COMPLIANT = "compliant",
  NON_COMPLIANT = "non_compliant",
  UNCERTAIN = "uncertain",
}
